import { categoryGradient } from '@core/utils/categoryVisual'
import { categoryIconUrlByName } from './categoryIconAssets'

export interface CategoryGlyphProps {
  /** Имя категории: из него выбирается SVG-иконка. */
  name: string
  /** Верхняя категория (отдел): только для fallback-градиента. */
  parent?: string | null
  /** Размер в px (квадрат). */
  size?: number
  /** Ручной override цвета (индекс палитры) — только для fallback. */
  colorKey?: number | null
  /** Устаревший override глифа: оставлен для совместимости вызовов. */
  glyph?: number | null
  className?: string
  /** Скругление фона: доля от размера (0.25 = 25%). */
  rounded?: number
}

/**
 * Визуал категории: SVG-иллюстрация из `src/assets/icons/categories/b`.
 *
 * Иконка выбирается по названию категории, масштабируется без потерь и
 * кешируется браузером. Если для вида нет файла — рисуется градиентный
 * квадрат, чтобы плитка не оставалась пустой.
 */
export function CategoryGlyph({
  name,
  parent,
  size = 40,
  colorKey,
  className,
  rounded = 0.25
}: CategoryGlyphProps) {
  const url = categoryIconUrlByName(name)

  if (url) {
    return (
      <img
        src={url}
        alt=""
        width={size}
        height={size}
        className={className}
        style={{ width: size, height: size, borderRadius: size * rounded }}
        aria-hidden="true"
      />
    )
  }

  const gradient = categoryGradient(parent || name, colorKey)
  return (
    <span
      className={className}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: size * rounded,
        background: `linear-gradient(135deg, ${gradient.from}, ${gradient.to})`
      }}
      aria-hidden="true"
    />
  )
}
